// Brands store module
// ---
//
// ------------------------------------------------------------------------- /
import apiService from '@/services/api';
import { logAndToastError, resetState } from '@/utils';
import { get } from 'lodash';

// Helpers
// ------------------------------------------------------------------------- /
const parseBrands = brands =>
	brands.map(brand => ({
		...brand,
		value: brand.id,
	}));

// Initial state
// ------------------------------------------------------------------------- /
const initialState = {
	items: [],
	brandsFetched: false,
	brandsFilterList: [],
	companyNumberRequirements: [],
};

// Getters
// ------------------------------------------------------------------------- /
const getters = {
	brands: state => state.items || [],
	brandsFetched: state => state.brandsFetched || false,
	brandCompanyNumberRequired: state => businessRelationId => {
		const brands = get(state, `items`, undefined);
		const brand = brands.find(item => item.manufacturer?.id === businessRelationId);
		const companyNumberRequired = brand?.companyNumberRequired;
		return companyNumberRequired ?? undefined;
	},
	brandCompanyNumberFormat: state => businessRelationId => {
		const brands = get(state, `items`, undefined);
		const brand = brands.find(item => item.manufacturer?.id === businessRelationId);
		const companyNumberFormat = brand?.companyNumberFormat;
		return companyNumberFormat ?? undefined;
	},
	getBrandNameById: state => brandId => {
		const brands = get(state, `items`, undefined);
		const brand = brands.find(item => item.id === brandId);
		return brand?.name ?? undefined;
	},
	getCompanyNumberRequirementsByCountry: state => country => {
		return state.companyNumberRequirements.find(requirement => requirement.country === country);
	},
	brandsFilterList: state => get(state, 'brandsFilterList', []),
};

// Actions
// ------------------------------------------------------------------------- /
const actions = {
	getAllBrands({ commit, state }, businessRelationId) {
		if (!state.items.length) {
			const url = `/manufacturer/brands?businessRelationId=${businessRelationId}`;
			apiService
				.get(url)
				.then(({ data: brands }) => {
					commit('setBrands', parseBrands(brands));
					commit('setBrandsFetched', true);
				})
				.catch(err => {
					logAndToastError(commit, 'Failed to get all brands from the server', err, { url });
					commit('setBrandsFetched', true);
				});
		}
	},
	getBrandsFilterList({ commit }, { businessRelationId }) {
		const url = `/businessrelations/${businessRelationId}/brands/selectlist`;
		apiService
			.get(url)
			.then(({ data: brands }) => {
				// runtime validation to ensure the brand object has the required properties
				commit('setBrandsFilterList', { brands: brands.filter(brand => !!brand?.id && !!brand?.name) });
			})
			.catch(err => {
				logAndToastError(commit, this.$t('error.failedToGetBrandsFilterList'), err, { url });
			});
	},
	resetBrands({ commit }) {
		commit('resetBrands');
	},
};

// Mutations
// ------------------------------------------------------------------------- /
const mutations = {
	setBrands(state, brands) {
		state.items = brands;
	},
	setBrandsFetched(state, fetched) {
		state.brandsFetched = fetched;
	},
	setCompanyNumberRequirementsPerCountry(state, companyNumberRequirements) {
		state.companyNumberRequirements = companyNumberRequirements;
	},
	setBrandsFilterList(state, { brands }) {
		state.brandsFilterList = brands;
	},
	resetBrands(state) {
		resetState(state, initialState);
	},
};

export default {
	state: { ...initialState },
	getters,
	actions,
	mutations,
};
